/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicVerifyPhoneRouteImport } from './routes/_public/verify-phone'
import { Route as PublicVerifyEmailRouteImport } from './routes/_public/verify-email'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicRegisterRouteImport } from './routes/_public/register'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppFiscalProfileRouteImport } from './routes/_app/fiscal-profile'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppCertificatesRouteImport } from './routes/_app/certificates'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppSuppliersIndexRouteImport } from './routes/_app/suppliers/index'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppPlansIndexRouteImport } from './routes/_app/plans/index'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices/index'
import { Route as AppDeclarationsIndexRouteImport } from './routes/_app/declarations/index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicVerifyPhoneRoute = PublicVerifyPhoneRouteImport.update({
  id: '/verify-phone',
  path: '/verify-phone',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicVerifyEmailRoute = PublicVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicRegisterRoute = PublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFiscalProfileRoute = AppFiscalProfileRouteImport.update({
  id: '/fiscal-profile',
  path: '/fiscal-profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCertificatesRoute = AppCertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSuppliersIndexRoute = AppSuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPlansIndexRoute = AppPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDeclarationsIndexRoute = AppDeclarationsIndexRouteImport.update({
  id: '/declarations/',
  path: '/declarations/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AppAccountRoute
  '/certificates': typeof AppCertificatesRoute
  '/dashboard': typeof AppDashboardRoute
  '/fiscal-profile': typeof AppFiscalProfileRoute
  '/notifications': typeof AppNotificationsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/register': typeof PublicRegisterRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/verify-phone': typeof PublicVerifyPhoneRoute
  '/clients/': typeof AppClientsIndexRoute
  '/declarations/': typeof AppDeclarationsIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/plans/': typeof AppPlansIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/suppliers/': typeof AppSuppliersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AppAccountRoute
  '/certificates': typeof AppCertificatesRoute
  '/dashboard': typeof AppDashboardRoute
  '/fiscal-profile': typeof AppFiscalProfileRoute
  '/notifications': typeof AppNotificationsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/register': typeof PublicRegisterRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/verify-phone': typeof PublicVerifyPhoneRoute
  '/clients': typeof AppClientsIndexRoute
  '/declarations': typeof AppDeclarationsIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/plans': typeof AppPlansIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/suppliers': typeof AppSuppliersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_app/account': typeof AppAccountRoute
  '/_app/certificates': typeof AppCertificatesRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/fiscal-profile': typeof AppFiscalProfileRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/register': typeof PublicRegisterRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/verify-email': typeof PublicVerifyEmailRoute
  '/_public/verify-phone': typeof PublicVerifyPhoneRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/declarations/': typeof AppDeclarationsIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/plans/': typeof AppPlansIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/suppliers/': typeof AppSuppliersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/certificates'
    | '/dashboard'
    | '/fiscal-profile'
    | '/notifications'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/verify-phone'
    | '/clients/'
    | '/declarations/'
    | '/invoices/'
    | '/plans/'
    | '/products/'
    | '/suppliers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/certificates'
    | '/dashboard'
    | '/fiscal-profile'
    | '/notifications'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/verify-phone'
    | '/clients'
    | '/declarations'
    | '/invoices'
    | '/plans'
    | '/products'
    | '/suppliers'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_public'
    | '/_app/account'
    | '/_app/certificates'
    | '/_app/dashboard'
    | '/_app/fiscal-profile'
    | '/_app/notifications'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/register'
    | '/_public/reset-password'
    | '/_public/verify-email'
    | '/_public/verify-phone'
    | '/_app/clients/'
    | '/_app/declarations/'
    | '/_app/invoices/'
    | '/_app/plans/'
    | '/_app/products/'
    | '/_app/suppliers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/verify-phone': {
      id: '/_public/verify-phone'
      path: '/verify-phone'
      fullPath: '/verify-phone'
      preLoaderRoute: typeof PublicVerifyPhoneRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/verify-email': {
      id: '/_public/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof PublicVerifyEmailRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/register': {
      id: '/_public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof PublicRegisterRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/fiscal-profile': {
      id: '/_app/fiscal-profile'
      path: '/fiscal-profile'
      fullPath: '/fiscal-profile'
      preLoaderRoute: typeof AppFiscalProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/certificates': {
      id: '/_app/certificates'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof AppCertificatesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/suppliers/': {
      id: '/_app/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AppSuppliersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/plans/': {
      id: '/_app/plans/'
      path: '/plans'
      fullPath: '/plans/'
      preLoaderRoute: typeof AppPlansIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/declarations/': {
      id: '/_app/declarations/'
      path: '/declarations'
      fullPath: '/declarations/'
      preLoaderRoute: typeof AppDeclarationsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppCertificatesRoute: typeof AppCertificatesRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppFiscalProfileRoute: typeof AppFiscalProfileRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppDeclarationsIndexRoute: typeof AppDeclarationsIndexRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
  AppPlansIndexRoute: typeof AppPlansIndexRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
  AppSuppliersIndexRoute: typeof AppSuppliersIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppCertificatesRoute: AppCertificatesRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppFiscalProfileRoute: AppFiscalProfileRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppDeclarationsIndexRoute: AppDeclarationsIndexRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
  AppPlansIndexRoute: AppPlansIndexRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
  AppSuppliersIndexRoute: AppSuppliersIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicRegisterRoute: typeof PublicRegisterRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicVerifyEmailRoute: typeof PublicVerifyEmailRoute
  PublicVerifyPhoneRoute: typeof PublicVerifyPhoneRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicRegisterRoute: PublicRegisterRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicVerifyEmailRoute: PublicVerifyEmailRoute,
  PublicVerifyPhoneRoute: PublicVerifyPhoneRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
